<template>
  <div class="page-component-wrapper">
    <div
      class="form-side"
      v-show="isVisible"
      v-loading="isLoading">
      <h1 class="page-title">{{formTitle}}</h1>
      <div class="profile-form-wrapper white-background">
        <form-profile
          :data="data"
          :model="formModel"
          @change="handleFormData"
          @updateModelItem="handlerUpdateModelItem"
          ref="Form"/>
        <form-controls
          :isSave="true"
          class="form-footer"
          @command="setCommand"/>
      </div>
    </div>
  </div>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { api } from '@/services/api'

export default {
  name: 'EditorProfile',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-profile': () => import(/* webpackChunkName: 'Profile' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  data () {
    return {
      api: 'AppUsers/Get/',
      // eslint-disable-next-line
      apiPatch: 'AppUsers/Patch/${data.id}',
      isVisible: true,
      currentID: this.$store.getters.get('currentUser').id
    }
  },
  computed: {
    formTitle () {
      return [this.formData.firstName, this.formData.lastName].filter(Boolean).join(' ')
    }
  },
  methods: {
    formModel () {
      return {
        thumbnailPath: '',
        firstName: '',
        lastName: '',
        userPath: '',
        emailDisplayName: '',
        emailSignature: '',
        employeeID: '',
        smtpHost: '',
        smtpPort: '',
        smtpPassword: ''
      }
    },
    handlerRoute () {
      this.requestGetData()
    },
    save () {
      this.$refs.Form.validate()
        .then(_ => {
          this.isLoading = true
          this.checkExecuteFirst().then(_ => {
            api
              .patch(`AppUsers/Patch/${this.currentID}`, this.$refs.Form.getData())
              .then(response => {
                this.isLoading = false
                this.$store.dispatch('getCurrentAppUser')
                this.requestSuccessHandler(response, this.L10n('done'))
              })
              .catch(response => {
                this.isLoading = false
                this.requestErrorHandler(response, this.L10n('error-update-item'))
              })
          })
        })
    }
  }
}
</script>

<style lang="stylus">
</style>
